import React, {Component} from 'react'
import styled from 'styled-components'
import {Nav, Navbar, Image, Button, NavbarBrand, NavDropdown, Container} from 'react-bootstrap'
import fire from '../database/firebase'
import MediaQuery from 'react-responsive';


const Styles = styled.div `

// .navbarContainer {
//     width: 100%;
// }

.navbar {
    background-color: #fff;
}

.logo-image {
    width: 50px; /* Adjust the width as needed */
    height: 50px; /* Adjust the height as needed */
    margin-right: 0.5%; /* Adjust the margin as needed */
}

.navbar-brand {
    // background-color: white;
    font-size: 25.5px;
    color: black;
    font-family: dm sans;
    // padding-left: 1%;
}

.navbarLogo:hover {
    color: #FF962D;
}
  
  /* Style for the navigation links */
.navbar-nav {
    margin-left: auto; /* Push links to the right */
    margin-right: 25%;
}

.navLink {
    margin-right: 50%;
    font-size: 18.5px;
    margin-left: 50%;
}
  
  /* Style for individual navigation link items */
.nav-link {
    color: #000;
    // font-weight: bold;
    font-family: dm sans;
}
  
  /* Hover effect for navigation links (optional) */
.nav-link:hover {
    text-decoration: none;
    color: #FF962D; 
}

  /* Style for the collapsed (mobile) Navbar button (optional) */
.navbar-toggler-icon {
    color: white;
}

    /* Style for the expanded (mobile) Navbar background (optional) */
.navbar-expand-lg .navbar-collapse {
    background-color: #fff;
}
  
  
.signUpBtnContainer {
    margin-left: 2.5%;
}

.signUpBtn {
    width: 160px;
    background-color: #FFB76F;
    color: white;
    border: 2px solid #FFB76F;
    font-family: dm sans;
    color: black;
    font-weight: bold;
}
  
.signUpBtn:focus {
    background-color: #FFB76F;
    color: black;
    border: 2px solid #FFB76F;
}

    // - - HEADER TOP - - //

.headerTop:after {
    content: "";
    display: table;
    clear: both;
}

.headerTopCol {
    float: left;
    text-align: right;
    width: 50%;
}

.headerTopCol img {
    width: 90%;
}

    // - - HEADER - - //

.header {
    // padding-left: 2.5%;
    width: 100%;
    height: 95vh;
    // background-image: url('./assets/granolaNotesBg3.86.png');
    // background-size: cover;
    // background-position: center; 
}

.header h1 {
    // font-family: DM Sans;
    // margin-left: 1.25%;
    // margin-bottom: 0px;
    // font-size: 27px;
}

.header img {
    width: 100%;
    // margin-left: 2.5%;
}


        // - - -  NOTES - - - //

    // - NOTES HEADER - //

.notesHeader {
    margin-left: 2%;
}

.notesHeader button {
    font-weight: bold;
    padding: 1%;
    margin-bottom: 3%;
    // color: #FF962D;
    background-color: #FFB76F;
    border: 2px solid #FFB76F;
    border-radius: 30px;
    font-family: sora;
}

    // - NOTES CONTENT - //

.note {
    float: left;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-left: 2.35%;
    height: 50vh;
    padding-top: 0.25%;
    width: 22%;
    // background-color: #F8AB35;
    margin-bottom: 3%;
    border-radius: 8px;
    // border-bottom: 10px solid #F8AB35;
    font-family: sora;
}

.note h5 {
    padding-top: 3.5%;
    padding-left: 2%;
    font-family: sora;
    font-weight: bold;
}

.note label {
    padding-bottom: 0%;
}

.note a {
    font-size: 80%;
    margin-left: 2.5%;
    margin-right: 2.5%;
    margin-top: 2%;
    // margin-bottom: 4%;
    display: inline-block; /* Make the <a> tag a block element */
    max-width: 96%; /* Set maximum width */
    overflow: hidden; /* Hide overflowing content */
    white-space: nowrap; /* Prevent text from wrapping onto a new line */
    text-overflow: ellipsis;
}

.note p {
    // margin-top: 3.5%;
    font-size: 85%;
}


`

export default class Landing extends Component {
    constructor() {
        super()
        this.state = {
            allNotes: [],
        }

        const { colors, heights } = this.getRandomColorsAndHeights();
        this.colorIndex = 0;
        this.heightIndex = 0;
        this.colors = colors;
        this.heights = heights;
    }

    componentDidMount = () => {
        this.loadAllNotes()
    }


    loadAllNotes = () => {
        class Note {
            constructor(color, note, number, platform, website) {
                this.color = color
                this.note = note
                this.number = number
                this.platform = platform
                this.website = website
            }
            toString () {
                return this.color + ', ' +
                this.note + ', ' +
                this.number + ', ' +
                this.platform + ', ' +
                this.website
            }
        }
        var noteConverter = {
            toFirestore : function(note) {
                return {
                    color: note.color,
                    note: note.note,
                    number: note.number,
                    platform: note.platform,
                    website: note.website
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new Note(data.color, data.note, data.number, data.platform, data.website)
            }
        }
        fire.firestore().collection("notes")
        .doc("all")
        .collection("list")
        .withConverter(noteConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            this.setState({
                allNotes: data
            })
        })
    }

    shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };
    
    getRandomColorsAndHeights = () => {
        const colors = ['#ffbd59', '#ffde59', '#e47b39', '#f8ab35'];
        const heights = Array.from({ length: 8 }, (_, i) => i + 52); // Generate an array from 50 to 57.5
        const shuffledColors = this.shuffleArray(colors);
        const shuffledHeights = this.shuffleArray(heights);
        
        return { colors: shuffledColors, heights: shuffledHeights };
    };

    renderAllNotes = () => {
        if (this.state.allNotes.length !==0) {
            // const { colors, heights } = this.getRandomColorsAndHeights();
            // let colorIndex = 0;
            // let heightIndex = 0;
            let colorIndex = 0;

            return (this.state.allNotes.map((notes, index) => {
                var {color, note, number, platform, publicNote, source, website} = notes
                if (index % 4 === 0) {
                    const rowColors = this.shuffleArray(this.colors);

                    const rowBackgroundColor1 = rowColors[0];
                    const rowBackgroundColor2 = rowColors[1];
                    const rowBackgroundColor3 = rowColors[2];
                    const rowBackgroundColor4 = rowColors[3];

                    const rowHeight1 = `${this.heights[this.heightIndex % this.heights.length]}vh`;
                    const rowHeight2 = `${this.heights[(this.heightIndex + 1) % this.heights.length]}vh`;
                    const rowHeight3 = `${this.heights[(this.heightIndex + 2) % this.heights.length]}vh`;
                    const rowHeight4 = `${this.heights[(this.heightIndex + 3) % this.heights.length]}vh`;

                    this.heightIndex += 4;

                    return (
                        <div style={{marginBottom: "0px"}}>
                            {this.state.allNotes[index] && 
                                <div className='notesContent'>
                                    <div style={{backgroundColor: rowBackgroundColor1, height: rowHeight1, borderBottom: `10px solid ${rowBackgroundColor1}`, clear: "left"}} className='note'>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                            <h5>
                                                <span style={{ backgroundColor: "white", padding: "3%", paddingLeft: "7.5%", paddingRight: "7.5%", borderRadius: "8px", paddingBottom: "6.5%", whiteSpace: "nowrap"}}>
                                                    <label style={{ fontSize: "67.5%", paddingLeft: "8.5%", paddingRight: "8.5%", color: this.state.allNotes[index].color }}>
                                                        {this.state.allNotes[index].platform}
                                                    </label>
                                                </span>
                                            </h5>
                                            <p style={{ whiteSpace: "pre-line", margin: 0, fontWeight: "bold", marginRight: "2%", paddingTop: "1%"}}>
                                                ({this.state.allNotes[index].number})
                                            </p>
                                        </div>
                                        <a 
                                        style={{
                                            textDecoration: this.state.allNotes[index].website ? "underline" : "none",
                                            color:  this.state.allNotes[index].website ? "#0d6efd" : "black",
                                            fontWeight: this.state.allNotes[index].website ? "normal" : "bold",
                                        }}
                                        href={this.state.allNotes[index].website ? this.state.allNotes[index].website : "#"}>{this.state.allNotes[index].website ? this.state.allNotes[index].website : "[Private]"}</a>
                                        <p style={{whiteSpace: "pre-line", paddingLeft: "2%", paddingRight: "2%", paddingBottom: "1.5%"}}>{this.state.allNotes[index].note.replaceAll("\\n", "\n")}</p>
                                    </div>
                                </div>
                            }
                            {this.state.allNotes[index+1] && 
                                <div className='notesContent'>
                                    <div style={{backgroundColor: rowBackgroundColor2, height: rowHeight2, borderBottom: `10px solid ${rowBackgroundColor2}`}} className='note'>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                            <h5>
                                                <span style={{ backgroundColor: "white", padding: "3%", paddingLeft: "7.5%", paddingRight: "7.5%", borderRadius: "8px", paddingBottom: "6.5%", whiteSpace: "nowrap"}}>
                                                    <label style={{ fontSize: "67.5%", paddingLeft: "8.5%", paddingRight: "8.5%", color: this.state.allNotes[index+1].color }}>
                                                        {this.state.allNotes[index+1].platform}
                                                    </label>
                                                </span>
                                            </h5>
                                            <p style={{ whiteSpace: "pre-line", margin: 0, fontWeight: "bold", marginRight: "2%", paddingTop: "1%" }}>
                                                ({this.state.allNotes[index+1].number})
                                            </p>
                                        </div>
                                        <a 
                                        style={{
                                            textDecoration: this.state.allNotes[index+1].website ? "underline" : "none",
                                            color:  this.state.allNotes[index+1].website ? "#0d6efd" : "black",
                                            fontWeight: this.state.allNotes[index+1].website ? "normal" : "bold",
                                        }}
                                        href={this.state.allNotes[index+1].website ? this.state.allNotes[index+1].website : "#"}>{this.state.allNotes[index+1].website ? this.state.allNotes[index+1].website : "[Private]"}</a>
                                        <p style={{whiteSpace: "pre-line", paddingLeft: "2%", paddingRight: "2%", paddingBottom: "1.5%"}}>{this.state.allNotes[index+1].note.replaceAll("\\n", "\n")}</p>
                                    </div>
                                </div>
                            }
                            {this.state.allNotes[index+2] && 
                                <div className='notesContent'>
                                    <div style={{backgroundColor: rowBackgroundColor3, height: rowHeight3, borderBottom: `10px solid ${rowBackgroundColor3}`}} className='note'>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                            <h5>
                                                <span style={{ backgroundColor: "white", padding: "3%", paddingLeft: "7.5%", paddingRight: "7.5%", borderRadius: "8px", paddingBottom: "6.5%", whiteSpace: "nowrap"}}>
                                                    <label style={{ fontSize: "67.5%", paddingLeft: "8.5%", paddingRight: "8.5%", color: this.state.allNotes[index+2].color }}>
                                                        {this.state.allNotes[index+2].platform}
                                                    </label>
                                                </span>
                                            </h5>
                                            <p style={{ whiteSpace: "pre-line", margin: 0, fontWeight: "bold", marginRight: "2%", paddingTop: "1%" }}>
                                                ({this.state.allNotes[index+2].number})
                                            </p>
                                        </div>
                                        <a 
                                        style={{
                                            textDecoration: this.state.allNotes[index+2].website ? "underline" : "none",
                                            color:  this.state.allNotes[index+2].website ? "#0d6efd" : "black",
                                            fontWeight: this.state.allNotes[index+2].website ? "normal" : "bold",
                                        }}
                                        href={this.state.allNotes[index+2].website ? this.state.allNotes[index+2].website : "#"}>{this.state.allNotes[index+2].website ? this.state.allNotes[index+2].website : "[Private]"}</a>
                                        <p style={{whiteSpace: "pre-line", paddingLeft: "2%", paddingRight: "2%", paddingBottom: "1.5%"}}>{this.state.allNotes[index+2].note.replaceAll("\\n", "\n")}</p>
                                    </div>
                                </div>
                            }
                            {this.state.allNotes[index+3] && 
                                <div className='notesContent'>
                                    <div style={{backgroundColor: rowBackgroundColor4, height: rowHeight4, borderBottom: `10px solid ${rowBackgroundColor4}`}} className='note'>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                            <h5>
                                                <span style={{ backgroundColor: "white", padding: "3%", paddingLeft: "7.5%", paddingRight: "7.5%", borderRadius: "8px", paddingBottom: "6.5%", whiteSpace: "nowrap"}}>
                                                    <label style={{ fontSize: "67.5%", paddingLeft: "8.5%", paddingRight: "8.5%", color: this.state.allNotes[index+3].color }}>
                                                        {this.state.allNotes[index+3].platform}
                                                    </label>
                                                </span>
                                            </h5>
                                            <p style={{ whiteSpace: "pre-line", margin: 0, fontWeight: "bold", marginRight: "2%", paddingTop: "1%" }}>
                                                ({this.state.allNotes[index+3].number})
                                            </p>
                                        </div>
                                        <a 
                                        style={{
                                            textDecoration: this.state.allNotes[index+3].website ? "underline" : "none",
                                            color:  this.state.allNotes[index+3].website ? "#0d6efd" : "black",
                                            fontWeight: this.state.allNotes[index+3].website ? "normal" : "bold",
                                        }}
                                        href={this.state.allNotes[index+3].website ? this.state.allNotes[index+3].website : "#"}>{this.state.allNotes[index+3].website ? this.state.allNotes[index+3].website : "[Private]"}</a>
                                        <p style={{whiteSpace: "pre-line", paddingLeft: "2%", paddingRight: "2%", paddingBottom: "1.5%"}}>{this.state.allNotes[index+3].note.replaceAll("\\n", "\n")}</p>
                                    </div>
                                </div>
                            }
                        </div>
                    )
                }
            }))
        }
    }

    render () {


        const computerMediaQuery = `(min-width: 1025px)`
        const tabletMediaQuery = `(min-width: 769px) and (max-width: 1024px)`; 
        const phabletMediaQuery = `(min-width: 415px) and (max-width: 768px)`
        // const standardPhoneQuery = `(min-width: 376px) and (max-width: 414px)`
        const smallPhoneQuery = `(min-width: 320px) and (max-width: 414px)`


        return (
            <Styles>
                <MediaQuery query={computerMediaQuery}>
                    <div>
                        <Navbar className='navbar' expand="lg">
                            <Image src="/assets/granolaNoats.png" alt="Your Logo" className="logo-image" />
                            <Navbar.Brand className='navbarLogo' href="/"><strong>granola notes</strong></Navbar.Brand>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ml-auto">
                                <Nav.Link className='navLink' href="/"><strong>notes</strong></Nav.Link>
                                <Nav.Link className='navLink' href="/about"><strong>about</strong></Nav.Link>
                                {/* <Nav.Link className='navLink' href=""><strong>Login</strong></Nav.Link> 
                                <Nav.Item className='signUpBtnContainer'>
                                    <Button href='/register' className='signUpBtn'>Sign Up</Button>
                                </Nav.Item>  */}
                            </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                    </div>
                    <div className='headerTop'>
                        <div className='headerTopCol'>
                            <img src='assets/gNotesTopHeader3.59.png'/>
                        </div>
                        <div className='headerTopCol'>
                            <img style={{paddingTop: "7.5%"}} src='assets/granolaNotesSecondHome3.5.png'/> 
                        </div>
                    </div>
                    <div className='resources'>
                        <h1 style={{textAlign: "center", fontFamily: "sora", fontWeight: "bold", marginTop: "0px", marginBottom: "1.5%"}}>notes</h1>
                    </div>
                    <div className='notes'>
                        <div className='notesHeader'>
                            <button style={{backgroundColor: "#FF962D", border: "2px solid #FF962D"}}
                            >All notes</button>
                            {/* <button style={{marginLeft: "2%"}}
                            >Psychology-backed</button>
                            <button style={{marginLeft: "2%"}}
                            >Public notes</button> */}
                        </div>
                        {this.renderAllNotes()}
                    </div>
                </MediaQuery>
                
                {/* <div className='header'> */}
                    {/* <img src='assets/granolaNotesBg3.9.png'/> */}
                    {/* <h1>granola notes</h1> */}
                    {/* <img src='assets/granolaNoats.png'/> */}
                {/* </div> */}
                {/* <div className='header'> */}
                    {/* <img src='assets/granolaNoatsPt2.65.png'/> */}
                {/* </div> */}
                {/* <div className='header'> */}
                    {/* <img src='assets/granolaNoatsPt4.85.png'/> */}
                {/* </div> */}
            </Styles>
        )
    }
}